import React, { Component } from 'react';
import __ from 'lodash';
import { connect } from 'react-redux';
import { cekCookies } from '../../../../../actions';
import { CONFIG, CONFIG_API_BE, URL_AKM } from '../../../../../config';
import accountManagement from '../../../../../apis/accountManagement';
import akmApi from '../../../../../apis/akmApi';
import eduprimeApi from '../../../../../apis/eduprimeApi';
import { Row, Col, Alert, Form } from 'react-bootstrap';


import LoaderModal from '../../../../modal/LoaderModal';
import Navbar from '../../../navbar/Navbar';
import Sidebar from '../../../sidebar/Sidebar';
import Loader from '../../../../Loader';


import DropdownProvinsi from '../../masterDropDown/DropdownProvinsi';
import DropdownKota from '../../masterDropDown/DropdownKota';
import DropdownSekolahEntity from '../../masterDropDown/DropdownSekolahEntity';
import { ta } from 'date-fns/locale';
import DropdownKodeJenjangSekolah from '../../masterDropDown/DropdownKodeJenjangSekolah';


class SekolahSnmptn extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            tahunAjaran: [],
            provinsi: [],
            kota: [],
            sekolah: [],
            idProvinsi: null,
            idKota: null,
            kodeJenjangSekolah: null,
            idSekolah: null,
            namaSekolahSearch: null,
            taAktif: null
        }
    }

    async componentDidMount() {
        await this.props.cekCookies();
        if (!__.isEmpty(this.props.account)) {
            this.fetchProvinsi();
            this.fetchTa();
        }
    }

    fetchTa = async () => {
        const respons = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_LIST_TAHUN_AJARAN, {})
        if (respons) {
            if (!__.isEmpty(respons.data.data)) {
                this.setState({
                    tahunAjaran: respons.data.data
                })
            }
        }
        respons.data.data.map((val, i) => {
            if (val.status === "1") {
                this.setState({ taAktif: val.kodeTahunAjaran })
            }
        })
    }

    fetchProvinsi = async () => {
        this.setState({ isSearch: true })
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_PROVINSI, {})
        if (respons) {
            if (!__.isEmpty(respons.data.list_provinsi)) {
                this.setState({
                    provinsi: respons.data.list_provinsi
                })
            }
        }
        this.setState({ isSearch: false })
    }

    handleProvinsiOnChange = async (e) => {
        const idProvinsi = e.target.value

        this.setState({
            isSearch: true,
            idKota: null,
            namaSekolahSearch: null
        })
        const respons = await eduprimeApi.get(CONFIG_API_BE.API_GET_KAB_KOTA + idProvinsi, {})
        if (respons) {
            if (!__.isEmpty(respons.data.list_kab_kota)) {
                this.setState({
                    kota: respons.data.list_kab_kota
                })
            }
        }
        this.setState({ isSearch: false })
    }

    handleKodeJenjangOnChange = async (e) => {
        this.setState({
            isFetching: true,
            namaSekolahSearch: "",
            kodeJenjangSekolah: e.target.value,
        })

        console.info("kodeJenjangSekolah", e.target.value);

        if (this.state.idKota !== null) {
            await akmApi.get(URL_AKM.SEKOLAH_SMA_SEDERAJAT + this.state.idKota + '/' + e.target.value, {})
                .then(res => {
                    if (res.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                        if (!__.isEmpty(res.data.data.listSekolah)) {
                            this.setState({
                                sekolah: res.data.data.listSekolah
                            })
                        }
                    } else {
                        this.setState({
                            sekolah: []
                        })
                    }
                })
                .catch(err => {
                    console.log("err", err);
                });
        }
        
        this.setState({
            isFetching: false
        })
    }

    handleKotaOnChange = async (e) => {
        const idKota = e.target.value
        this.setState({
            idKota: e.target.value,
            isSearch: true,
            namaSekolahSearch: null
        })

        await akmApi.get(URL_AKM.SEKOLAH_SMA_SEDERAJAT + idKota + '/' + this.state.kodeJenjangSekolah, {})
                .then(res => {
                    if (res.data.errorSchema.errorCode === URL_AKM.SUCCESS_ERROR_CODE) {
                        if (!__.isEmpty(res.data.data.listSekolah)) {
                            this.setState({
                                sekolah: res.data.data.listSekolah
                            })
                        }
                    } else {
                        this.setState({
                            sekolah: []
                        })
                    }
                })
                .catch(err => {
                    console.log("err", err);
                });
        this.setState({ isSearch: false })
    }



    handleOnChangeNamaSekolah = async (e) => {
        const namaSekolah = e.target.value;

        if (this.state.idKota !== '' && this.state.idSekolah !== '') {
            this.setState({
                namaSekolahSearch: e.target.value,
                isSearch: true
            })

            this.fetchSekolahRefres(namaSekolah);
        }
    }

    fetchSekolahRefres = async (namaSekolah) => {
        const respons = await akmApi.post(URL_AKM.SEKOLAH_SEARCH_BY_LIKE, {
            ['idKabupatenKota']: this.state.idKota,
            ['kodeJenjangSekolah']: this.state.kodeJenjangSekolah,
            ['namaSekolah']: namaSekolah,
        })
        if (respons) {
            if (!__.isEmpty(respons.data.data)) {
                this.setState({
                    sekolah: respons.data.data
                })
            }
        }
        this.setState({ isSearch: false })
    }


    render() {
        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching} />
                <Sidebar account={this.props.account} />
                <div id="content" style={{ paddingBottom: '50px' }}>
                    <Navbar title="Manajemen Akses SNMPTN Sekolah" />
                    {this.loadAlert()}
                    <Row>
                        <Col>
                            <div className="form-group">
                                <select className="form-control" name="idProvinsi" id="idProvinsi"
                                    value={this.state.idProvinsi}
                                    onChange={this.handleProvinsiOnChange} >
                                    <option value="">Pilih Provinsi...</option>
                                    <DropdownProvinsi provinsi={this.state.provinsi} />
                                </select>
                            </div>
                        </Col>
                        <Col>
                            <div className="form-group">
                                <select className="form-control" name="kodeJenjangSekolah" id="kodeJenjangSekolah"
                                    value={this.state.kodeJenjangSekolah}
                                    onChange={this.handleKodeJenjangOnChange} >
                                    <option value="">Pilih Kode Jenjang...</option>
                                    <DropdownKodeJenjangSekolah />
                                </select>
                            </div>
                        </Col>
                        <Col>
                            <div className="form-group">
                                <select className="form-control" name="idKota" id="idKota"
                                    value={this.state.idKota}
                                    onChange={this.handleKotaOnChange} >
                                    <option value="">Pilih Kota...</option>
                                    <DropdownKota kota={this.state.kota} />
                                </select>
                            </div>
                        </Col>
                        {/* <Col>
                            <div className="form-group">                                  
                                <select className="form-control" name="idSekolah" id="idSekolah" 
                                    onChange={this.handleSekolahOnChange} >
                                    <option value="">Pilih Sekolah...</option>
                                    <DropdownSekolahEntity sekolah={this.state.sekolah}/>
                                </select>
                            </div>
                        </Col>  */}
                    </Row>
                    <Row>
                        <Col xs={12} md={9}>

                        </Col>
                        <Col xs={6} md={3}>
                            <Form.Group controlId="namaSekolah">
                                <Form.Control
                                    type="text"
                                    onChange={this.handleOnChangeNamaSekolah}
                                    placeholder="Cari Sekolah.."
                                    value={this.state.namaSekolahSearch} />
                            </Form.Group>
                        </Col>
                    </Row>
                    {this.loading()}
                    <Row>
                        <Col xs={12} md={12}>
                            {this.renderTableSekolah()}
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }

    loading = () => {
        if (this.state.isSearch) {
            return (
                <Loader />
            )
        }
    }

    loadAlert = () => {
        const { alertShow } = this.state;
        if (alertShow) {
            return (
                <Alert variant="danger" onClose={() => this.setState({ alertShow: false })} dismissible>
                    <strong>{this.state.resMessage}</strong>
                </Alert>
            );
        }
    }

    renderTableSekolah() {
        return (
            <table className="table table-sm table-striped table-hover">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Nama Sekolah</th>
                        <th style={{ "text-align-last": "center" }}>Tgl Update</th>
                        <th style={{ "text-align-last": "center" }}>Kode Tahun Ajaran</th>
                        <th style={{ "text-align-last": "center" }}>Status</th>
                        <th style={{ "text-align-last": "center" }}>Aksi</th>
                    </tr>
                </thead>
                <tbody>
                    {this.renderChildSekolah()}
                </tbody>
            </table>
        )
    }

    renderChildSekolah() {
        if (!__.isEmpty(this.state.sekolah)) {
            return this.state.sekolah.map((val, i) => {
                const status = this.state.taAktif === val.tahunAjaranSnmptn ? 1 : 0;
                return (
                    <tr>
                        <td>{i + 1}</td>
                        <td>{val.namaSekolah}</td>
                        <td style={{ "text-align-last": "center" }}>
                            {val.registrationDateSnmptn == null ?
                                "-" :
                                // (new Date(val.registrationDateSnmptn)).toString()

                                new Intl.DateTimeFormat('en-GB', {
                                    month: 'numeric',
                                    day: '2-digit',
                                    year: 'numeric',
                                    hour: 'numeric',
                                    minute: 'numeric',
                                    second: 'numeric'
                                }).format(new Date(val.registrationDateSnmptn))
                            }
                        </td>
                        <td style={{ "text-align-last": "center" }}>
                            {val.tahunAjaranSnmptn == null ?
                                "-" : val.tahunAjaranSnmptn
                            }
                        </td>
                        <td style={{ "text-align-last": "center" }}>
                            {
                                this.state.taAktif === val.tahunAjaranSnmptn ?
                                    <button className="btn btn-outline-primary">
                                        Aktif
                                    </button>
                                    :
                                    <button className="btn btn-outline-danger">
                                        Non Aktif
                                    </button>
                            }
                        </td>
                        <td style={{ "text-align-last": "center" }}>
                            {val.tahunAjaranSnmptn != this.state.taAktif ?
                                <button className="btn btn-info" title="Registrasi SNMPTN" onClick={() => this.doHandleRegis(this.state.taAktif, val)}>
                                    <li className="fa fa-check"></li>
                                </button>
                                :
                                <button className="btn btn-danger" title="Hapus Registrasi SNMPTN" onClick={() => this.doHandleRegis('-', val)}>
                                    <li className="fa fa-times"></li>
                                </button>
                            }
                        </td>
                    </tr>
                )
            })
        }
    }

    doHandleRegis = async (stt, val) => {
        this.setState({ isSearch: true })
        const handleBukaTutup = await akmApi.post(URL_AKM.AKTFKAN_NONAKTIFKAN_SNMPTN, {
            ['idSekolah']: val.idSekolah,
            ['idKabupatenKota']: val.idKabupatenKota,
            ['idProvinsi']: val.idProvinsi,
            ['namaSekolah']: val.namaSekolah,
            ['kodeJenjangSekolah']: val.kodeJenjangSekolah,
            ['tahunAjaranSnmptn']: stt,
            ['registrationDateSnmptn']: 0,
        }).catch(function (error) {
            console.error(error);
        })

        this.fetchSekolahRefres(this.state.namaSekolahSearch);

        this.setState({ isSearch: false })

    }

}


const mapStateToProps = (state) => {
    return {
        account: state.account
    };
}

export default connect(mapStateToProps, { cekCookies })(SekolahSnmptn);